export default __webpack_public_path__ + "static/media/settings-265131_1920.8fccb648.png";